import { useEffect, useState } from 'react';

import { Modal, ModalContent, ModalHeader, ModalSidebar, Tab, Tabs, useDeviceType } from '@braskai/ui-kit';

import { Stack } from '@mui/material';

import { useTeamspaceSettingsModal } from '@/features/teamspace';
// import { ApiKeyManager } from '@/features/user/manageApiKey';

import { useLocation } from 'react-router-dom';

import { DiscardChangesModal, useCurrentSpaceId, useGetSpaceById } from '@/entities/teamspace';

import { PATHS } from '@/shared/constants/routes/paths';

import { EditTeamspaceForm, UsageView } from './tabs';

type TabName = 'api' | 'settings' | 'usage';

export const TeamspaceSettingsModal = () => {
  const teamspaceId = useCurrentSpaceId();
  const { data: space } = useGetSpaceById(teamspaceId);
  const location = useLocation();

  const [activeTab, setActiveTab] = useState<TabName>('settings');
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [isDiscardModalOpen, setIsDiscardModalOpen] = useState(false);

  const { close, isOpen } = useTeamspaceSettingsModal();

  const { isMobile } = useDeviceType();

  const handleClose = () => {
    if (hasUnsavedChanges) {
      setIsDiscardModalOpen(true);
    } else {
      close();
    }
  };

  const handleContinueEditing = () => {
    setIsDiscardModalOpen(false);
  };

  const onDiscardChanges = () => {
    setIsDiscardModalOpen(false);
    setHasUnsavedChanges(false);
    close();
  };

  useEffect(() => {
    if (!location.pathname.includes(PATHS.spaces)) close();
  }, [close, location.pathname]);

  return (
    <>
      <Modal open={isOpen} size="md" onClose={handleClose}>
        <ModalHeader.Container gap={16} underline onClose={handleClose}>
          <ModalHeader.Title maxLines={1} mr={40}>
            {space?.name || 'Teamspace'}
          </ModalHeader.Title>
          {isMobile ? (
            <Tabs value={activeTab} variant="bordered" onChange={(_, value) => setActiveTab(value)}>
              <Tab label="Settings" data-testid="settings-tab" value="settings" />
              <Tab label="Usage" data-testid="usage-tab" value="usage" />
              {/* <Tab label="API" value="api" /> */}
            </Tabs>
          ) : null}
        </ModalHeader.Container>

        <Stack direction="row">
          <ModalSidebar>
            <Tabs
              orientation="vertical"
              value={activeTab}
              variant="secondary"
              onChange={(_, value) => setActiveTab(value)}
            >
              <Tab label="Settings" data-testid="settings-tab" value="settings" />
              <Tab label="Usage" data-testid="usage-tab" value="usage" />
              {/* <Tab label="API" value="api" /> */}
            </Tabs>
          </ModalSidebar>

          <Stack width="100%">
            <ModalContent
              height="600px"
              sx={{ paddingBottom: '24px !important', ...(activeTab === 'settings' ? { px: '0 !important' } : {}) }}
              width={isMobile ? '100%' : '540px'}
            >
              {activeTab === 'settings' && (
                <EditTeamspaceForm teamspaceId={teamspaceId} setHasUnsavedChanges={setHasUnsavedChanges} />
              )}
              {activeTab === 'usage' && <UsageView teamspaceId={teamspaceId} onClose={close} />}
              {/* {activeTab === 'api' && <ApiKeyManager variant="compact" />} */}
            </ModalContent>
          </Stack>
        </Stack>
      </Modal>

      <DiscardChangesModal isOpen={isDiscardModalOpen} onCancel={handleContinueEditing} onDiscard={onDiscardChanges} />
    </>
  );
};
